module.exports = __webpack_public_path__ + "static/media/m-headshot-alice.c2e50ce9.png";